import { useCurrentUserQuery } from 'api';
import { useCallback, useMemo } from 'react';

export const useAccessControl = () => {
  const userId = JSON.parse(localStorage.getItem('userId') || 'null');

  const { data = {} } = useCurrentUserQuery({ userId }, { skip: !userId });

  const permissions = useMemo(() => {
    return data?.permissions || [];
  }, [data]);

  const hasAccess = useCallback(
    (role: string = '') => {
      const permissionDetails = role.split(':');
      const permission = permissionDetails[permissionDetails?.length - 1];
      return (permission && permissions.includes(`all:${permission}`)) || permissions.includes(role);
    },
    [permissions]
  );

  return { hasAccess };
};
